export const UserTypes = {
  FETCH_BALANCE: "FETCH_BALANCE",
  SET_BALANCE: "SET_BALANCE",
  FETCH_PROFILE: "FETCH_PROFILE",
  SET_PROFILE: "SET_PROFILE",
  BROADCAST_SHOW_CASHIER: "BROADCAST_SHOW_CASHIER",
  BROADCAST_SWITCH_DEVICE: "BROADCAST_SWITCH_DEVICE",
  BROADCAST_SESSION_EXPIRED: "BROADCAST_SESSION_EXPIRED",
  BROADCAST_GAME_MODE: "BROADCAST_GAME_MODE",
  BROADCAST_NEW_UPDATE: "BROADCAST_NEW_UPDATE"
};
